import _get from 'lodash/get'
import { baseRequest } from '.'

export const toggleOrderResale = async (eventId, orderId, data) => {
  const res = await baseRequest.post(`events/${eventId}/orders/${orderId}/resale-status/`, {
    data,
  })

  return _get(res, 'data')
}

export const markOrderAsPaid = async (eventId, orderId, data) => {
  const res = await baseRequest.post(`events/${eventId}/orders/${orderId}/complete-pending-order/`, {
    data,
  })

  return _get(res, 'data')
}

export const rejectPendingOrder = async (eventId, orderId, data) => {
  const res = await baseRequest.post(`events/${eventId}/orders/${orderId}/reject-pending-order/`, {
    data,
  })

  return _get(res, 'data')
}

export const issueGuestAddOn = async (eventId, data) => {
  const res = await baseRequest.post(`events/${eventId}/guest-add-ons`, {
    data: { attributes: data },
  })

  return _get(res, 'data')
}

export const requestRefundOrderAuthCode = async (orderHash) => {
  const res = await baseRequest.post(`/orders/${orderHash}/request-code`)

  return _get(res, 'data')
}

export const refundOrder = async (orderHash, code) => {
  const res = await baseRequest.post(`/orders/${orderHash}/refund`, {
    data: {
      code: code
    }
  })

  return _get(res, 'data')
}

export const revokeCode = async (orderHash) => {
  const res = await baseRequest.post(`/orders/${orderHash}/revoke-code`)

  return _get(res, 'data')
}

export const resendCode = async (orderHash) => {
  const res = await baseRequest.post(`/orders/${orderHash}/resend-code`)

  return _get(res, 'data')
}